export class Producto{
    constructor(
        public _id?: string,
        public nombre?: string,
        public descripcion?: string,
        public categoria?: any,
        public costo_usd?: number,
        public costo_sugerido?: number,
        public precio_usd?: number,
        public precio_sugerido?: number,
        public details?: any,
        public personalizable?: boolean,
        public tiempo_elaboracion?: number,
        public costo?: number,
        public precio?: number,
        public image?: string,
        public company?: string,
        public tienda?: boolean,
    ){}
}